import { MDBBtn, MDBIcon, MDBModalFooter } from "mdb-react-ui-kit";
import React, { forwardRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { getMisc } from "../../../../apiclients/streamsapi_bridge";
import { getMultiSelectRequest, setMultiSelectValue } from "../../misc/MultiSelectRequest";
import PopupLoader from "../../PopupLoader";
import MultiSaveLimitAlert from "../../../../apiclients/MultiSaveLimitAlert";

const ChangePermissionRole = forwardRef((props, ref) => {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const [roles, setRoles] = useState([]);
    const [roleid, setRoleid] = useState(-1);

    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [warningMsg, setwarningMsg] = useState([]);
    const [showWarning, setShowWarning] = useState(false);
    const warningToggle = () => setShowWarning(!showWarning);
    const [saveWarningMessage, setsaveWarningMessage] = useState("");
    const [allEntriesDicard, setAllEntriesDicard] = useState(false);

    useEffect(() => {
        getPermssionRole();

    }, []);
    async function getPermssionRole() {
        props.setIsloading(true);
        const tdata = await getMultiSelectRequest(7, props.agentList, props.moduleType);
        props.setIsloading(false);
        if (!tdata) {
            window.alert(`info with id  not found`);
            navigate("/");
        }

        setRoles(tdata?.result?.option_list ?? []);
        setwarningMsg(tdata?.result?.message ? [tdata?.result?.message] : []);

    }

    async function handlePermissionRoleChange(value) {
        props.setIsloading(true);
        const tdata = await setMultiSelectValue(7, value + "", props.agentList, props.moduleType);
        props.setIsloading(false);
        if (!tdata) {
            window.alert(`info with id  not found`);
            navigate("/");
        }
        console.log("handlePermissionRoleChange for multi select ::::::::::::: " + JSON.stringify(tdata));
        const reponseMsg = tdata.display_Info ?? [];
        if (reponseMsg.length > 0) {
            setwarningMsg(reponseMsg);
        }
    }

    async function onsubmit(confirmFlag) {
        if (parseInt(roleid) === -1) {
            setError("Please select a Role");
            return;
        }
        let tdata = null;
        props.setIsloading(true);
        if (confirmFlag) {
            tdata = await setMultiSelectValue(7, roleid + "", props.agentList, props.moduleType, 1, 1);
        } else {
            tdata = await setMultiSelectValue(7, roleid + "", props.agentList, props.moduleType, 1);
        }
        props.setIsloading(false);
        if (!tdata) {
            window.alert(`info with id  not found`);
            navigate("/");
        }
        if (tdata.status == "Failed") {
            localStorage.setItem(
                "user_create_f",
                "Something went wrong, Please try again after sometime"
            );
            props.onClose();
            window.location.href = "/userlanding";
        } else if (tdata.status == "failed") {
            if (tdata.exceededErrMsg) {
                setsaveWarningMessage(tdata.exceededErrMsg);
                if(tdata.all_grps_discarded) {
                    setAllEntriesDicard(true);
                }
                warningToggle();
                return;
            }
        } else {
            console.log("roleid for multi select ::::::::::::: " + JSON.stringify(tdata));
            localStorage.setItem("s_message", tdata.message);

            if (props.locUser) {
                navigate("/locationsusers", {
                    state: { tab: props.locUser },
                });

            } else if (props.groupInfo) {
                navigate("/usersgroups", {
                    state: { tab: props.groupInfo },
                });

            } else if (props.groupUInfo) {
                navigate("/SelectedUserGroupSettings", {
                    state: { tab: "tab2", groupUInfo: props.groupUInfo },
                });
            } else if (props.usergroups) {
                navigate("/userlanding", {
                    state: { tab: "mgroups" },
                });

            } else if (props.userLoc) {
                navigate("/userlanding", {
                    state: { tab: "suser", tab2: "sloc" },
                });

            } else if (props.userAllgroups) {
                navigate("/userlanding", {
                    state: { tab: "suser", tab2: "sgroups" },
                });


            } else {
                navigate("/userlanding", {
                    state: { tab: "suser", tab2: "suser" },
                });
            }
            // props.onClose();

            window.location.reload();
        }


    }

    return (
        <>
            <div className="w-100 " style={{ paddingBottom: 125 }}>
                <div>
                    <strong className=" d-block">
                        {t("PermissionRole")}
                    </strong>
                    <select
                        className="form-select form-control mt-2 w-100"
                        name="408 702 2241"
                        value={roleid}
                        onChange={(e) => {
                            setRoleid(e.target.value);
                            if (parseInt(e.target.value) === -1) {
                                setError("Please select a Role");
                            } else {
                                setError("");
                                handlePermissionRoleChange(e.target.value);
                            }
                        }}
                    >
                        <option value={-1}>-- Select Role --</option>
                        {roles && roles.length > 0 && roles.map((role) => (
                            <option value={role.id}>{role.name}</option>
                        ))}
                    </select>
                    {error && (
                        <p className="text-danger">{error}</p>
                    )}
                </div>
                {warningMsg && warningMsg.map((meg) => (
                    <div className="pt-2 phrecording">
                        {meg}
                    </div>
                ))}
            </div>
                <div style={{ display: "none" }}>
                    <button ref={ref} onClick={(e) => {
                        e.preventDefault();
                        onsubmit();
                    }}>
                        {t("add")}</button>
                </div>
            {showWarning && (
                <>
                    <PopupLoader
                        title="Warning"
                        content={
                            <MultiSaveLimitAlert
                                saveWarningMessage={saveWarningMessage}
                                onClose={warningToggle}
                                handleClick={() => { if(allEntriesDicard) {warningToggle(); props.onClose(); return;}onsubmit(1);}}
                            />
                        }
                        onShow={setShowWarning}
                        onClose={warningToggle}
                    />

                </>
            )}
        </>
    )
});

export default ChangePermissionRole
